import { Box, Typography, Button } from '@mui/material';
import ApproveDialog from '../approve-dialog';
import { useState } from 'react';
import { PendingActionCardProps } from '../../../common/utils/interfaces';
import dayjs from 'dayjs';
import { useMutation } from '@apollo/client';
import { EDIT_MEMBER_APPROVAL_REQUEST } from '../../gql';
import { ApprovalRequestType } from '../../../common/utils/enum';

function PendingActionCardForReminderNotifications({
  id,
  description,
  date,
  newStatus,
  state
}: PendingActionCardProps): JSX.Element {
  const [open, setOpen] = useState(false);

  const handleClickOpen = (): void => {
    setOpen(true);
  };

  const handleClose = (): void => {
    setOpen(false);
  };
  const [editMemberApprovalRequest] = useMutation(EDIT_MEMBER_APPROVAL_REQUEST);
  const [cardStatus, setCardStatus] = useState<string>(state);

  const handleReject = async (): Promise<void> => {
    await editMemberApprovalRequest({
      variables: {
        input: {
          id,
          action: 'REJECT',
          comment: ''
        }
      }
    }).then((res) => {
      setCardStatus(ApprovalRequestType.REJECTED);
    });
  };
  const ApproveLables = [
    { value: 'ONGOING', label: 'Change status to Executing' },
    {
      value: 'HYPERCARE_SUPPORT',
      label: 'Change status to Hypercare support'
    },
    { value: 'COMPLETED', label: 'Change status to Completed' }
  ];
  const getLabel = (status?: string): string => {
    const labelObj = ApproveLables.find((item) => item.value === status);
    return labelObj ? labelObj.label : 'Change status';
  };
  return (
    <Box
      sx={{
        marginBottom: '12px',
        padding: '12px',
        borderRadius: '12px',
        border: '1px solid rgba(95, 99, 104, 0.5)'
      }}
    >
      <ApproveDialog
        id={id}
        open={open}
        comment=""
        handleClose={handleClose}
        setApprovelStatus={function (value: { status: string }): void {
          setCardStatus(value.status as unknown as ApprovalRequestType);
        }}
      />
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          width: '100%',
          height: 'auto'
        }}
      >
        <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
          <Box
            sx={{
              overflow: 'hidden',
              marginBottom: '16px'
            }}
          >
            <Typography
              sx={{
                fontSize: '16px',
                fontWeight: 500,
                fontFamily: 'Be Vietnam Pro',
                lineHeight: '24px',
                letterSpacing: '0.15px'
              }}
            >
              {description}
            </Typography>
          </Box>
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center'
            }}
          >
            <Typography
              sx={{
                fontSize: '13px',
                fontWeight: '400',
                color: 'rgba(116, 119, 127, 1)',
                display: 'flex',
                justifyContent: 'flex-end'
              }}
            >
              {dayjs(date).format('MMM D, YYYY, h:mm:ss A')}
            </Typography>
          </Box>
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'space-between',
              gap: '16px',
              marginBottom: '16px'
            }}
          >
            {cardStatus === 'PENDING' ? (
              <>
                <Button
                  onClick={handleClickOpen}
                  variant="outlined"
                  sx={{
                    borderRadius: '100px',
                    padding: '10px 24px',
                    textTransform: 'none',
                    height: 'auto'
                  }}
                >
                  <Typography>{getLabel(newStatus)}</Typography>
                </Button>
                <Button
                  onClick={() => {
                    void (async () => {
                      await handleReject();
                    })();
                  }}
                  variant="contained"
                  color="primary"
                  size="small"
                  sx={{
                    backgroundColor: 'rgba(226, 236, 246, 1)',
                    borderRadius: '100px',
                    padding: '10px 24px',
                    textTransform: 'none',
                    height: 'auto',
                    boxShadow: 'none',
                    color: '#295DAB'
                  }}
                >
                  <Typography>Extend</Typography>
                </Button>
              </>
            ) : (
              <Typography
                style={{
                  color: 'rgba(40, 164, 67, 1)',
                  alignSelf: 'center',
                  fontFamily: 'Be Vietnam Pro',
                  fontSize: '14px',
                  fontWeight: '500',
                  lineHeight: '20px',
                  letterSpacing: '0.1px'
                }}
              >
                {cardStatus === 'APPROVED' ? 'Status changed' : 'Extended'}
              </Typography>
            )}
          </Box>
        </Box>
      </Box>
    </Box>
  );
}

export default PendingActionCardForReminderNotifications;
